var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showFold)?_c('div',[_c('Subtitle',{staticStyle:{"height":"9%","padding-top":"3%"},attrs:{"subtitle":_vm.mainObj.subTitle}}),_c('div',{staticClass:"boxMain",staticStyle:{"height":"89%","padding-top":"1%"}},[_c('flightDetails',{attrs:{"subData":_vm.mainObj.subData}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }